import { CleanLink } from '@components/gassan-ui/Link/CleanLink'
import LocalizedLink from '@components/Localization/LocalizedLink'
import { Button, Icon, Link as RolexLink } from '@components/old-rolex-ui'
import { cn } from '@lib/cn'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import React, { useState } from 'react'

const RCPOHeader: React.FC = () => {
  const router = useRouter()
  const [isMobileActive, setIsMobileActive] = useState(false)
  const {
    t,
    i18n: { language },
  } = useTranslation('navigation')

  const disableMobileMenu = () => setIsMobileActive(false)
  const toggleMobileMenu = () => setIsMobileActive(!isMobileActive)

  const navItems: { label: string; href: string }[] = [
    {
      label: t('rcpo.index.title'),
      href: `${t('rcpo.index.url')}`,
    },
    {
      label: t('rcpo.selection.title'),
      href: `${t('rcpo.selection.url')}`,
    },
    {
      label: t('rcpo.certification.title'),
      href: `${t('rcpo.certification.url')}`,
    },
    {
      label: t('rcpo.contact.title'),
      href: `${t('rcpo.contact.url')}`,
    },
  ]

  return (
    <>
      <div className="relative z-[3]">
        <header
          className={cn(
            'mx-auto flex h-[78px] w-full max-w-[1680px] items-center justify-between border-b border-solid border-shade-200 bg-white px-5',
            'xl:h-[100px] xl:px-10',
          )}
        >
          <CleanLink
            href={
              language === 'nl' ? `${t('rcpo.index.url')}` : `/${language}${t('rcpo.index.url')}`
            }
          >
            <img
              src="/images/rcpo/rolex-certified-pre-owned-logo.svg"
              alt="RCPO retailer plaque"
              className={cn('mt-[1px] h-[42px] w-[100px]', 'xl:mt-[0px] xl:h-[67px] xl:w-[160px]')}
            />
          </CleanLink>
          <nav className="hidden justify-end gap-[30px] lg:flex">
            {navItems.map((item, key) => {
              const cleanHref = item.href.replace(`/${language}`, '')
              const isActive = cleanHref === router.asPath
              return (
                // Don't map over the last item, that's the contact button
                key !== navItems.length - 1 && (
                  <LocalizedLink href={item.href} key={key}>
                    <RolexLink
                      type="link"
                      variant="primary"
                      className={cn(isActive ? 'text-rolexPrimary' : '!text-rolexShade-900')}
                    >
                      {item.label}
                    </RolexLink>
                  </LocalizedLink>
                )
              )
            })}
            <Button
              as="link"
              href={navItems[navItems.length - 1].href}
              variant="secondary"
              style={{ maxWidth: 275 }}
            >
              {navItems[navItems.length - 1].label}
            </Button>
          </nav>
          <button
            className={cn(
              'flex items-center border-none text-sm text-rolexShade-900 outline-none',
              'lg:hidden',
              isMobileActive && 'text-rolexPrimary',
              '-[&>svg]:ml-1 [&>svg]:transition-transform [&>svg]:duration-150',
              isMobileActive && '[&>svg]:rotate-180',
            )}
            onClick={() => toggleMobileMenu()}
          >
            MENU
            <Icon icon="rolex-mobile-menu-arrow" />
          </button>
        </header>
        <nav
          className={cn(
            'absolute block w-full max-w-[100vw] bg-white transition-all duration-150',
            isMobileActive ? 'pointer-events-auto' : 'pointer-events-none',
            isMobileActive ? 'translate-y-0' : '-translate-y-2',
            isMobileActive ? 'opacity-100' : 'opacity-0',
            'lg:hidden',
          )}
        >
          {navItems.map((item, key) => {
            const cleanHref = item.href.replace(`/${language}`, '')
            const isActive = cleanHref === router.asPath
            return (
              <LocalizedLink href={item.href} key={key}>
                <RolexLink
                  type="link"
                  variant="primary"
                  className={cn(
                    'h-10 w-full justify-center border-t border-solid border-shade-200',
                    isActive ? 'text-rolexPrimary' : '!text-rolexShade-900',
                    key === navItems.length - 1 && 'border-b',
                  )}
                  onClick={() => disableMobileMenu()}
                >
                  {item.label}
                </RolexLink>
              </LocalizedLink>
            )
          })}
        </nav>
        <button
          className={cn(
            'fixed left-0 top-0 -z-[1] h-[100vh] w-[100vw] ',
            isMobileActive ? 'pointer-events-auto' : 'pointer-events-none',
          )}
          onClick={() => disableMobileMenu()}
        />
      </div>
    </>
  )
}

export default RCPOHeader
